/* eslint-disable @next/next/no-img-element */
import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import * as Types from '../../pages/mijn-carel-lurvink/catalogus/stores/types';
import styles from './ProductDownloads.module.scss';

export const ProductDownloads = ({ files }: { files: Types.File[] }) => {
  const { t } = useTranslation('product-details');

  return (
    <>
      <h3 className="h2">{t('title.downloads')}</h3>

      <table className={`table ${styles.table}`}>
        <thead>
          <tr>
            <th className="pl-md-0">{t('header.document')}</th>
            <th>{t('header.language')}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {files.map((file) => {
            return (
              <tr onClick={() => window.open(file.src, '_blank')} key={file.src}>
                <td className="col-description pl-md-0">{file.description}</td>
                <td className="col-language">{file.languageCode}</td>
                <td className="col-download pr-md-0">
                  <a href={file.src} target="_blank" className="btn-outline-primary-square">
                    <span className="cl cl-download" />
                  </a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};
